<template>
  <el-dialog
    top="20vh"
    class="el-dialog-cus"
    v-bind="attributes"
    :visible="visible"
    :before-close="beClose"
    append-to-body
    :close-on-click-modal="false"
    :center="centerTag"
    v-on="on"
  >
    <slot class="dialogContent"></slot>
    <div v-if="btnsNeeded" slot="footer">
      <el-button v-if="btnTxt[0]" plain @click="cancel">{{ btnTxt[0] }}</el-button>
      <el-button v-if="btnTxt[1]" type="primary" class="orangeBGwhiteFont" @click="confirm">{{ btnTxt[1] }}</el-button>
      <slot name="btn1"></slot>
      <slot name="btn2"></slot>
    </div>
  </el-dialog>
</template>

<script>
import i18n from '@/lang';

export default {
  inheritAttrs: false,
  props: {
    config: {
      type: Object,
      default: () => ({
        width: '420px',
        title: i18n.t('提示'),
        center: false,
        btnTxt: [i18n.t('取消'), i18n.t('确定')]
      })
    },
    autoClose: {
      type: Boolean,
      default: true
    },
    beforeClose: {
      type: Function,
      default: () => {}
    },
    btnsNeeded: {
      type: Boolean,
      default: false
    },
    centerTag: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const { config } = this; const { btnTxt } = config;
    return {
      visible: false,
      attributes: config,
      btnTxt,
      on: this.getDialogEvents()
    };
  },
  methods: {
    open(ok) {
      this.ok = ok;
      this.visible = true;
    },
    cancel() {
      this.visible = false;
    },
    confirm() {
      const cancel = () => this.cancel();
      this.ok(cancel);
      this.autoClose && cancel();
    },
    beClose(done) {
      done();
      this.beforeClose();
      this.cancel();
    },
    getDialogEvents() {
      const { close } = this.config || {}; const events = {};

      if (close && typeof close === 'function') {
        Object.assign(events, {
          close
        });
      }

      return events;
    }
  }
};
</script>

<style lang="scss" scoped>
.el-dialog-cus {
  .el-dialog {
    padding: 8px;
  }
  .el-dialog__body{
    padding: 0 20px;
  }
  .el-dialog__title {
    font-weight: normal;
    font-size:16px;
  }
  .el-dialog__header {
    padding: 17px 0 17px 20px;
    border-bottom:1px solid #E9E9E9;
    margin-bottom:12px;
    .el-dialog__headerbtn .el-dialog__close{
      font-size:22px;
      color: #303133;
      margin:12px;
    }
  }
  .el-dialog__headerbtn {
    top: 8px;
    right: 8px;
  }
  .el-dialog--center .el-dialog__body {
    max-height: 500px;
    overflow: auto;
    padding: 0 24px;
    text-align: center;
  }
  .el-dialog__footer {
    padding: 20px;
    .el-button {
      padding: 8px 20px;
      & + .el-button {
        margin-left: 40px;
      }
    }
  }

  .btn-box{
    text-align:right;
    .el-button{
      width:68px;
      height:40px;
      font-size:14px;
    }
  }

  .dialogContent{
    border-bottom:1px solid #E9E9E9;
  }

  .el-form-item__label{
    font-weight:normal;
  }
}
</style>
